export enum AttendanceStatusIndication {
    None = 1,
    CapacityFull = 2,
    BookedOnLesson = 3,
}